import type { MeResponse } from '@wit-support/admin-contracts';

export async function fetchMe(baseUrl: string): Promise<MeResponse | null> {
  const r = await fetch(`${baseUrl}/api/me`, { credentials: 'include' });
  // 401 is the only signal that the operator is genuinely not authenticated —
  // map it to `null` so the gate shows the login screen.
  if (r.status === 401) return null;
  // Any other failure (5xx, network hiccup, etc.) is transient and must NOT be
  // treated as a logout. Throw so React Query retries and the gate keeps the
  // operator on a spinner/retry instead of bouncing them to login.
  if (!r.ok) throw new Error(`GET /api/me failed: ${r.status}`);
  return r.json();
}
